import {isFeatureEnabled} from '@github-ui/feature-flags'
import type {JSFeatureFlag} from '@github-ui/feature-flags/client-feature-flags'
import {useCachePreheatQuery} from '@github-ui/relay-query-cache/hooks/use-cache-preheat-query'
import {useMemo} from 'react'

import {IssueViewerViewGraphqlQuery} from '../components/IssueViewer'
import {IssueViewerSecondaryGraphqlQuery} from '../components/IssueViewerSecondaryView'

type useCachePreheatIssueViewerProps = {
  owner: string
  repo: string
  number: number
  source: string
  featureFlag: JSFeatureFlag
}

export function useCachePreheatIssueViewer({
  owner,
  repo,
  number,
  source,
  featureFlag,
}: useCachePreheatIssueViewerProps) {
  const preHeatingEnabled = isFeatureEnabled(featureFlag)
  const preHeatingEnabledForSecondary = isFeatureEnabled('issues_preheating_secondary')
  const excludeFromSecondaryQueryCacheKey = useMemo(() => ['markAsRead'], [])

  useCachePreheatQuery({
    query: IssueViewerViewGraphqlQuery,
    variables: {
      owner,
      repo,
      number,
      count: 15,
    },
    source,
    enabled: preHeatingEnabled,
  })

  useCachePreheatQuery({
    query: IssueViewerSecondaryGraphqlQuery,
    variables: {
      owner,
      repo,
      number,
      markAsRead: false,
    },
    source,
    enabled: preHeatingEnabled && preHeatingEnabledForSecondary,
    excludeFromCacheKey: excludeFromSecondaryQueryCacheKey,
  })
}
